RivalIQ.module('suggestion.views', function (views, App, Backbone, Marionette, $, _, async, s) {

    'use strict';

    const sources = RivalIQ.enums.sources;

    views.Modal = Marionette.LayoutView.extend({
        template: '#suggestionModalTemplate',
        className: 'modal',

        ui: {
            suggestInput: 'input',
            suggestBtn: '.x-suggestion-btn',
            removeBtn: '.x-remove-btn',
            validateBtn: '.x-validate-btn',
            removeLink: '.remove-handle',
            footer: '.modal-footer'
        },

        regions: {
            presence: '.presence'
        },

        events: {
            'click @ui.suggestBtn': 'submitSuggestion',
            'click @ui.removeBtn': 'submitSuggestion',
            'click @ui.validateBtn': 'handleValidateClick',
            'click @ui.removeLink': 'handleRemoveClick',
            'keypress @ui.suggestInput': 'handleKeypress',
            'input @ui.suggestInput': 'handleInputChange'
        },

        initialize: function () {
            const me = this;

            me.isValid = false;
            me.suggestion = null;
            me.validationSources = [
                sources.TWITTER,
                sources.FACEBOOK,
                sources.YOUTUBE,
                sources.INSTAGRAM,
                sources.TIKTOK
            ];
        },

        templateHelpers: function () {

            const me = this;
            const source = me.model.get('source');
            const data = RivalIQ.enums.sourceDetails[source];
            const channelHandle = me.model.get('channelHandle');
            const isCompanyModal = (source === RivalIQ.enums.sources.RIVALIQ);
            const isChannelEditModal = !isCompanyModal && channelHandle;

            return {
                name: (source === sources.RIVALIQ ? 'Company Name' : data.name),
                prompt: RivalIQ.suggestion.enums.message[source],
                isCompanyModal: isCompanyModal,
                isChannelEditModal: isChannelEditModal,
                exampleUrl: RivalIQ.suggestion.enums.placeholder[source]

            };
        },

        onShow: function () {
            const me = this;
            me.$el.modal();
            me.ui.suggestInput.focus();
            const source = me.model.get('source');

            // check if we need to validate the input before letting the user submit
            if (_.includes(me.validationSources, source)) {
                me.ui.suggestBtn.addClass('disabled');
                me.ui.footer.hide();
            } else {
                me.ui.validateBtn.hide();
            }

            // if the channel doesn't have an existing value hide the "remove" ui
            if (!me.model.get('channelHandle')) {
                me.ui.removeLink.hide();
            }

            me.ui.removeBtn.hide();
            me.ui.suggestBtn.show();
        },

        onRender: function () {
            const me = this;
            me.ui.suggestInput.select();
        },

        handleKeypress: function (e) {
            const me = this;

            if (e.keyCode === 13) {
                e.preventDefault();

                const source = me.model.get('source');

                // when we're validating inputs, "enter" is validate
                // when we're not validating inputs, enter is submit
                if (_.includes(me.validationSources, source)) {
                    me.validateSuggestion();
                } else {
                    me.submitSuggestion();
                }

            }
        },

        handleInputChange: function () {
            const me = this;

            if (me.isValid || me.model.get('removePresence')) {
                me.isValid = false;
                me.suggestion = null;
                me.ui.suggestBtn.addClass('disabled');
                me.ui.footer.hide();
                me.ui.validateBtn.button('reset');
            }

            if (!me.isValid && me.presence.hasView()) {
                me.presence.empty();
            }

            if (me.model.get('channelHandle')) {
                me.ui.removeLink.show();
                me.ui.removeBtn.hide();
                me.ui.suggestBtn.show();
            }
        },

        handleValidateClick: function () {
            const me = this;

            if (me.isValid) {
                me.ui.suggestInput.val('');
                me.handleInputChange();
            } else {
                me.validateSuggestion();
            }
        },

        handleRemoveClick: function () {
            const me = this;

            // clear any previous validated presence and set the "removePresence" flag
            me.model.set('removePresence', true);
            me.model.unset('presence');

            // Show the remove confirmation
            me.ui.removeBtn.show();
            me.ui.suggestBtn.hide();
            me.ui.footer.show();
        },

        getHandle: function () {
            const me = this;
            const source = me.model.get('source');
            let inputString = me.ui.suggestInput.val().trim();

            // NOTE the input string might be a URL, or might be a handle/native_id

            // strip leading @ if present
            if (inputString && inputString[0] === '@') {
                inputString = inputString.slice(1);
            }

            switch (source) {
                case sources.TWITTER:
                    return RivalIQ.utils.socialUrl.twitterUrlToHandle(inputString) || inputString;

                case sources.FACEBOOK:
                    return RivalIQ.utils.socialUrl.facebookUrlToHandle(inputString) || inputString;

                case sources.YOUTUBE:
                    return RivalIQ.utils.socialUrl.youtubeUrlToHandle(inputString) || inputString;

                case sources.INSTAGRAM:
                    return RivalIQ.utils.socialUrl.instagramUrlToHandle(inputString) || inputString;

                case sources.TIKTOK:
                    return RivalIQ.utils.socialUrl.tiktokUrlToHandle(inputString) || inputString;

                default:
                    throw new Error(`unknown source ${source}`);
            }
        },

        showPresence: function (model) {
            const me = this;

            const view = new views.Handle({
                model: model
            });

            me.ui.removeLink.hide();
            me.presence.show(view);
        },

        showError: function () {
            const me = this;
            const isFacebook = (me.model.get('source') === RivalIQ.enums.sources.FACEBOOK);
            const facebookOauthUrl = RivalIQ.channels.getOAuthUrl(RivalIQ.enums.sources.FACEBOOK);
            const isInstagram = (me.model.get('source') === RivalIQ.enums.sources.INSTAGRAM);
            const isYoutube = (me.model.get('source') === RivalIQ.enums.sources.YOUTUBE);
            const invalidHandle = me.ui.suggestInput.val().split('?')[0]; // strip any url parameters

            const view = new views.InvalidHandle({
                model: new Backbone.Model({
                    invalidHandle: invalidHandle,
                    isFacebook: isFacebook,
                    facebookOauthUrl: facebookOauthUrl,
                    isInstagram: isInstagram,
                    isYoutube: isYoutube
                })
            });

            me.ui.removeLink.hide();
            me.presence.show(view);
        },

        validateSuggestion: function () {
            const me = this;
            const source = me.model.get('source');

            // if we've already validated, it's time to submit
            if (me.isValid && me.suggestion === me.ui.suggestInput.val()) {
                return;
            }

            me.ui.removeLink.hide();
            me.presence.showLoading(null, {
                block: true
            });
            const handle = me.getHandle();

            const handleModel = new RivalIQ.models.SocialHandle({
                id: handle,
                source: source
            });

            const deferred = async.callbackToDeferred(function (error) {
                // NOTE if the view is destroyed we should not act
                if (me.isDestroyed) {
                    return;
                }

                if (error) {
                    me.showError();
                    me.isValid = false;
                    me.suggestion = null;
                    me.ui.footer.hide();
                } else {
                    me.model.set('presence', handleModel);
                    me.model.unset('removePresence');
                    me.showPresence(handleModel);

                    me.isValid = true;
                    me.suggestion = me.ui.suggestInput.val();

                    me.ui.suggestBtn.removeClass('disabled');
                    me.ui.suggestBtn.show();
                    me.ui.removeBtn.hide();
                    me.ui.footer.show();
                    me.ui.validateBtn.button('remove');
                }
            });

            handleModel.fetch({
                finderPicked: false
            }).done(deferred.resolve).fail(deferred.reject);
        },

        submitSuggestion: function () {

            const me = this;
            let message = me.ui.suggestInput.val();

            if (me.model.get('removePresence')) {
                message = `(remove ${me.model.get('decoratedHandle')})`;
            }

            if (!message.length) {

                return;
            }

            me.ui.suggestBtn.button('loading');

            const source = me.model.get('source');
            const data = RivalIQ.enums.sourceDetails[source];
            const type = (source === sources.RIVALIQ ? 'name' : data.channel);

            const suggestEdit = new RivalIQ.suggestion.models.Suggestion({
                companyId: me.model.get('companyId'),
                presence: me.model.get('presence'),
                removePresence: me.model.get('removePresence'),
                message: message,
                type: type
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SubmittedDataChangeRequest, {
                pathname: window.location.pathname
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.EditCompany, {
                // ex: channel can be instagram, name, and etc.
                channel: type
            });
            const deferred = async.callbackToDeferred(function (error, result) {
                // NOTE if the view is not destroyed we can act
                if (!me.isDestroyed) {
                    me.ui.suggestBtn.button('reset');
                }

                if (error) {
                    return RivalIQ.execute('alert:danger', 'An error occurred saving, please try again');
                }

                // NOTE if the view is not destroyed we can act
                if (!me.isDestroyed) {
                    me.$el.modal('hide');
                }

                me.trigger('submit', result.didEdit);

                let alertTemplate = '#suggestionAlertQuickTemplate';

                if (result.didEdit === true) {

                    // if it's a fast change (delete or name change)
                    if (result.didDelete || type === 'name') {

                        alertTemplate = '#suggestionAlertQuickTemplate';
                    } else {

                        alertTemplate = (RivalIQ.state.account.hasExtendedSocialContentHistory() ?
                            '#suggestionAlertExtendedSocialContentTemplate' :
                            '#suggestionAlertSocialContentTemplate');
                    }
                }

                // update token summary with presence
                const tokenSummary = RivalIQ.state.user.get(`${type}TokenSummary`);
                const presence = me.model.get('presence');
                if (presence) {
                    const token = _.find(tokenSummary, {
                        screen_name: presence.get('handle')
                    });
                    if (token) {
                        token.iconUrl = presence.get('profile_image_url');
                        RivalIQ.state.user.set(`${type}TokenSummary`, tokenSummary);
                    }
                }

                RivalIQ.execute('alert:info', {
                    template: alertTemplate
                });
            });

            suggestEdit.save().done(deferred.resolve).fail(deferred.reject);
        }

    });
}, RivalIQ.utils.async, window.s);
